"use client";

import AppHero from "src/components/Common/AppHero";
import TechStats from "src/components/Common/TechStats";
import FAQSection from "src/components/Common/FAQSection";
import WhyChooseUs from "src/components/Common/WhyChooseUs";
import TechsSection from "src/components/Common/TechsSection";
import ProcessStepsSection from "src/components/Common/ProcessStepsSection";
import PagesServicesSection from "src/components/Common/PagesServicesSection";
import NavigationSection from "src/components/Common/NavigationSection";
import {
  backendServices,
  backendFaqs,
  backendHeroData,
  backendStatsData,
  backendSolutionsAndProcessData,
  backendPortfolioData,
  backendTechnologiesData,
  backendAboutData,
} from "src/utils/mock/backendAppData";
import { caseStudies } from "src/utils/mock/caseStudies";
import CommonContactSection from "src/components/Common/CommonContactSection";

export default function BackendAppDevelopment({ caseStudies: apiCaseStudies }) {
  const finalCaseStudies = apiCaseStudies || caseStudies;
  const liveProjects = finalCaseStudies?.projects?.liveProjects || [];

  const backendProjects = liveProjects.filter((project) => {
    const isActive = project.projectStatus === "active";
    const webApp = project.platforms?.toLowerCase().includes("web") || project.platforms?.toLowerCase().includes("mobile");
    const hasBackendTech = project.technologies?.some((tech) => tech.name?.toLowerCase().includes("backend"));

    return isActive && webApp && hasBackendTech;
  });

  const filteredData = {
    ...backendPortfolioData,
    projects: {
      liveProjects: backendProjects,
    },
  };
  const techIcons = filteredData?.projects?.liveProjects[0]?.technologies;
  return (
    <div>
      <AppHero heroData={backendHeroData} />

      <TechStats stats={backendStatsData} />

      <NavigationSection data={backendServices} />
      <WhyChooseUs data={backendSolutionsAndProcessData} />

      <section className="w-full bg-background-primary text-white px-6! md:px-12! relative overflow-hidden font-sans">
        <div className="absolute top-1/4 right-0 w-[500px] h-[500px] bg-purple-900/10 blur-[150px] -z-10 rounded-full" />
        <div className="absolute bottom-1/4 left-0 w-[500px] h-[500px] bg-blue-950/20 blur-[150px] -z-10 rounded-full" />

        <div className="max-w-8xl mx-auto!">
          <PagesServicesSection data={filteredData} />
          <ProcessStepsSection data={backendTechnologiesData} techIcons={techIcons} />

          <TechsSection sections={backendAboutData} mainTitle="About Backend App Development" />
        </div>
      </section>

      <FAQSection faqs={backendFaqs} />
      <CommonContactSection />
    </div>
  );
}
